export const ZIP_DETAIL = 'ZIP_DETAIL'
export const ZIP_EXPLORE = 'ZIP_EXPLORE'

export const QUESTION_ACKNOWLEDGED_MARKET_TEMP = 'acknowledged_market_temp'
